export default __webpack_public_path__ + "static/media/4-cassettes-open-3-left.e8f1667c.svg";